<div class="container">
  <h1 class="section-title">
    {{ isEditMode ? 'Edit Company' : 'Create Company' }}
  </h1>

  <div
    class="loading"
    *ngIf="isEditMode && (companyStore.loading() || !isFormReady)"
  >
    Loading company...
  </div>

  <form
    data-testid="company-form"
    *ngIf="!companyStore.loading() && isFormReady"
    [formGroup]="form"
    [noValidate]="true"
    (ngSubmit)="submit()"
  >
    <h2 class="section-sub-title">Company Details</h2>

    <div class="six-inputs">
      <app-company-input
        [initValue]="currentCompany?.name ?? ''"
        [controllerName]="'company'"
      ></app-company-input>

      <div class="area">
        <app-country-options-input
          [countryOptions]="countryOptions"
          [initValue]="currentCompany?.country ?? ''"
          [formGroupName]="'country'"
        ></app-country-options-input>
        <app-state-or-province-input
          [controllerName]="'stateOrProvince'"
          [initValue]="currentCompany?.stateOrProvince ?? ''"
        ></app-state-or-province-input>
        <app-postalcode-input
          [initValue]="currentCompany?.postalCode ?? ''"
          [controllerName]="'postalcode'"
        ></app-postalcode-input>
      </div>

      <app-industry-options-input
        [initValue]="currentCompany?.industry ?? ''"
        [formGroupName]="'industry'"
        [fieldsApplicationOptions]="fieldsApplicationOptions"
        (applicationsForIndustry)="changeOptions($event)"
      ></app-industry-options-input>

      <app-applications-options-input
        [selectedOptions]="currentCompany?.fieldsOfApplication ?? []"
        [changeOptions]="applicationOptions"
        [formGroupName]="'application'"
      >
      </app-applications-options-input>
    </div>

    <app-response-banner
      [success]="successfulSave"
      [successMessage]="successMessage"
      [errorMessage]="errorMessage"
      [invisible]="!showResponseBanner"
    ></app-response-banner>

    <div class="button-box">
      <app-button [title]="'Cancel'" (click)="cancelForm()"></app-button>
      <app-button
        [tall]="true"
        [title]="isEditMode ? 'Update Company' : 'Create Company'"
        testId="company-save"
        [disabled]="form.invalid || companyStore.saving()"
      ></app-button>
    </div>
  </form>
</div>
